export default {
  product: 'Product',
  sushiSet: 'SushiSet',
  ingredient: 'Ingredient',
}
